module.exports = __webpack_public_path__ + "static/Ice@2x.d6cb91cc.png";